import classes from './Card_brown.module.css'

function CardBrown(props){
  return <div className = {classes.card}>{props.children}</div>
}

export default CardBrown;